import { IRequest } from '@r1-frontend/shared/types/IRequest';

const suggest = (query: string): IRequest => ({
    uri: 'v1/addresses/suggest',
    method: 'POST',
    body: JSON.stringify({ query }),
    withProvider: true,
});

export default suggest;
